<!-- main content start -->
<div class="main-content">
    <div class="breadcrumb mb-30">
        <h2>Dashboard</h2>
        <!-- <div class="input-group filter">
            <input type="text" class="form-control" name="basic" id="dashboardFilter" readonly>
            <label for="dashboardFilter" class="input-group-text"><i class="fa fa-calendar-days"></i></label>
        </div> -->
    </div>
        <div class="row mb-30">
        <div class="col-lg-4 col-6 col-xs-12">
            <div class="top-box rounded-bottom panel-bg h-100">
                <div class="left">
                    <h3>₹34,152</h3>
                    <p>Shipping fees are not</p>
                    <a href="#">View net earnings</a>
                </div>
                <div class="right">
                    <span class="text-primary">+16.24%</span>
                    <div class="part-icon rounded">
                        <span><i class="fa fa-rupee-sign"></i></span>
                    </div>
                </div>
            </div>
        </div>
        <div class="col-lg-4 col-6 col-xs-12">
            <div class="top-box rounded-bottom panel-bg h-100">
                <div class="left">
                    <h3>{{ orderSummary.total }}</h3>
                    <p class="fw-bold mb-1">Total Orders</p>
                </div>
                <div class="right">
                    <span class="text-primary mb-1">Order summary</span>
                    <span>Completed: {{ orderSummary.completed }}</span>
                    <span>Pending: {{ orderSummary.pending }}</span>
                    <span>Today: {{ orderSummary.today }}</span>
                    <div class="part-icon rounded mt-2">
                        <span><i class="fa fa-bag-shopping"></i></span>
                    </div>
                </div>
            </div>
        </div>
        <div class="col-lg-4 col-6 col-xs-12">
            <div class="top-box rounded-bottom panel-bg h-100">
                <div class="left">
                    <h3>₹34,152</h3>
                    <p>Customers</p>
                    <a href="#">See details</a>
                </div>
                <div class="right">
                    <span class="text-primary opacity-0">+16.24%</span>
                    <div class="part-icon rounded">
                        <span><i class="fa fa-user"></i></span>
                    </div>
                </div>
            </div>
        </div>
        <!-- <div class="col-lg-3 col-6 col-xs-12">
            <div class="top-box rounded-bottom panel-bg">
                <div class="left">
                    <h3>₹724,152</h3>
                    <p>My Balance</p>
                    <a href="#">Withdraw</a>
                </div>
                <div class="right">
                    <span class="text-primary">+16.24%</span>
                    <div class="part-icon rounded">
                        <span><i class="fa fa-credit-card"></i></span>
                    </div>
                </div>
            </div>
        </div> -->
    </div>
    <div class="row">
        <div class="d-none col-xxl-8">
            <div class="panel chart-panel-1">
                <div class="panel-header">
                    <h5>Sales Analytics</h5>
                    <div class="btn-box">
                        <button class="btn btn-sm btn-outline-primary">Week</button>
                        <button class="btn btn-sm btn-outline-primary">Month</button>
                        <button class="btn btn-sm btn-outline-primary">Year</button>
                    </div>
                </div>
                <div class="panel-body">
                    <div id="saleAnalytics" class="chart-dark"></div>
                </div>
            </div>
        </div>
        <div class="d-none col-xxl-4 col-md-6">
            <div class="panel">
                <div class="panel-header">
                    <h5>Social Media Visitor</h5>
                    <div class="btn-box d-sm-block d-none">
                        <button class="btn btn-sm btn-outline-primary">Week</button>
                        <button class="btn btn-sm btn-outline-primary">Month</button>
                        <button class="btn btn-sm btn-outline-primary">Year</button>
                    </div>
                </div>
                <div class="panel-body">
                    <table class="table table-borderless visitor-table">
                        <thead>
                            <tr>
                                <th>Sources</th>
                                <th>Visitor</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr>
                                <td><span class="text-fb"><i class="fa-brands fa-facebook-f"></i></span> Facebook</td>
                                <td>153,100</td>
                            </tr>
                            <tr>
                                <td><span class="text-behance"><i class="fa-brands fa-behance"></i></span> Behance</td>
                                <td>234,200</td>
                            </tr>
                            <tr>
                                <td><span class="text-comb"><i class="fa-brands fa-y-combinator"></i></span> Combinator</td>
                                <td>326,012</td>
                            </tr>
                            <tr>
                                <td><span class="text-insta"><i class="fa-brands fa-instagram"></i></span> Instagram</td>
                                <td>124,420</td>
                            </tr>
                            <tr>
                                <td><span class="text-dribble"><i class="fa-brands fa-dribbble"></i></span> Dribble</td>
                                <td>554,220</td>
                            </tr>
                            <tr>
                                <td><span class="text-pinterest"><i class="fa-brands fa-pinterest-p"></i></span> Pinterest</td>
                                <td>134,800</td>
                            </tr>
                            <tr>
                                <td><span class="text-linkedin"><i class="fa-brands fa-linkedin-in"></i></span> Linkedin</td>
                                <td>254,812</td>
                            </tr>
                            <tr>
                                <td><span class="text-twitter"><i class="fa-brands fa-twitter"></i></span> Twitter</td>
                                <td>124,250</td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>
        </div>
        <div class="col-xxl-8">
            <div class="panel h-100">
                <div class="panel-header">
                    <h5>Recent Orders</h5>
                    <div id="tableSearch"></div>
                </div>
                <div class="panel-body">
                    <table class="table table-dashed recent-order-table" id="myTable">
                        <thead>
                            <tr>
                                <th>Order ID</th>
                                <th>Customer</th>
                                <th>Order Date</th>
                                <th>Payment Method</th>
                                <th>Delivery Date</th>
                                <th>Total Amount</th>
                                <th>Status</th>
                                <th>Action</th>
                            </tr>
                        </thead>
                        <tbody>
                            @for (item of dashBoardData.latest_orders; track $index) {
                                    <tr>
                                    <td>{{item.id}}</td>
                                    <td>{{item.user.name}}</td>
                                  <td>{{ item.created_at | date:'dd-MM-yy' }}</td>
                                    <td>{{item.payment_method}}</td>
                                    <td>02/11/22</td>
                                    <td>₹{{item.total_amount}}</td>
                                    <td><span class="badge bg-success">{{item.status}}</span></td>
                                    <td>
                                        <div class="btn-box">
                                            <button type="button" (click)="openOrderPreview(item)"><i class="fa fa-eye"></i></button>
                                            <button type="button" (click)="downloadInvoice(item)" title="Download Invoice">
                                                <i class="fa fa-file-invoice"></i>
                                            </button>
                                            <!-- <button><i class="fa fa-pen"></i></button> -->
                                            <!-- <button><i class="fa fa-trash"></i></button> -->
                                        </div>
                                    </td>                                </tr>
                                }
                        </tbody>
                    </table>
                    <!-- <div class="table-bottom-control"></div> -->
                </div>
            </div>
        </div>
        <div class="col-xxl-4 col-md-6">
            <div class="panel h-100">
                <div class="panel-header">
                    <h5>New Customers</h5>
                    <button class="btn btn-sm btn-icon btn-outline-primary"><i class="fa fa-ellipsis-vertical"></i></button>
                </div>
                <div class="panel-body">
                    <table class="table table-dashed recent-order-table">
                        <tbody>
                            @for (item of dashBoardData.new_customers; track $index) {

                                <tr>
                                    <td>
                                        <div class="new-customer">
                                            <!-- <div class="part-img">
                                                <img src="../images/avatar.png" alt="Image">
                                            </div> -->
                                            <div class="part-txt">
                                                <p class="customer-name mb-0">{{item.name}}</p>
                                                <span>{{item.email}}</span>
                                            </div>
                                        </div>
                                    </td>
                                    <td>{{item.orders_count}} Orders</td>
                                    <td>₹{{item.orders_sum_total_amount==null?0:item.orders_sum_total_amount}}</td>
                                </tr>
                            }

                        </tbody>
                    </table>
                </div>
            </div>
        </div>
    </div>

    <!-- footer start -->
    <div class="footer">
        <p>Copyright© <script>document.write(new Date().getFullYear())</script> All Rights Reserved By <span class="text-primary">safure</span></p>
    </div>
    <!-- footer end -->
</div>
<!-- main content end -->

<ng-template #orderPreviewModal let-modal>
    <div class="modal-header">
        <h5 class="modal-title">Order Preview</h5>
        <button type="button" class="btn-close" aria-label="Close" (click)="modal.dismiss()"></button>
    </div>
    <div class="modal-body">
        <div class="row g-2">
            <div class="col-md-6"><strong>Order ID:</strong> {{ selectedOrder?.id || '-' }}</div>
            <div class="col-md-6"><strong>Status:</strong> {{ selectedOrder?.status || '-' }}</div>
            <div class="col-md-6"><strong>Customer:</strong> {{ selectedOrder?.user?.name || '-' }}</div>
            <div class="col-md-6"><strong>Email:</strong> {{ selectedOrder?.user?.email || '-' }}</div>
            <div class="col-md-6"><strong>Payment Method:</strong> {{ selectedOrder?.payment_method || '-' }}</div>
            <div class="col-md-6"><strong>Total Amount:</strong> ₹{{ selectedOrder?.total_amount ?? 0 }}</div>
            <div class="col-md-6"><strong>Created At:</strong> {{ selectedOrder?.created_at ? (selectedOrder?.created_at | date:'dd-MM-yyyy, hh:mm a') : '-' }}</div>
            <div class="col-md-6"><strong>Updated At:</strong> {{ selectedOrder?.updated_at ? (selectedOrder?.updated_at | date:'dd-MM-yyyy, hh:mm a') : '-' }}</div>
        </div>
    </div>
    <div class="modal-footer">
        <button type="button" class="btn btn-secondary" (click)="modal.dismiss()">Close</button>
    </div>
</ng-template>
